import {createRef} from "../createRef";

export default createRef({
    "id": "FILIAL_FOR_CONTEXT_V",
    "source": "FILIAL_FOR_CONTEXT_V",
    "context": "userFilialFilterContextStrategy",
    "fields": [
        {   "column": "filial", },
        {   "column": "name", },
    ],
});
